import { render, staticRenderFns } from "./TrasegadoForm.vue?vue&type=template&id=2acef9d0&"
import script from "./TrasegadoForm.vue?vue&type=script&lang=js&"
export * from "./TrasegadoForm.vue?vue&type=script&lang=js&"
import style0 from "./TrasegadoForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports